var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-wrap" },
    [
      _c("ActionsBar", { attrs: { pageTitle: "orders" } }),
      _vm._v(" "),
      !_vm.loader
        ? _c("v-card", { attrs: { "pa-4": "" } }, [
            _c(
              "div",
              { staticClass: "data-wrap mt-4" },
              [
                _c(
                  "v-expansion-panels",
                  { staticClass: "orders" },
                  _vm._l(_vm.list, function(item, key) {
                    return _c(
                      "v-expansion-panel",
                      { key: key },
                      [
                        _c("v-expansion-panel-header", [
                          _c("div", [
                            _c("div", { staticClass: "status-wrap" }, [
                              _c("span", { class: item.status + " status" }, [
                                _vm._v(_vm._s(item.status))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.parseDate(item.created_at)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("v-expansion-panel-content", [
                          _c("div", { staticClass: "order-details" }, [
                            _c("div", { staticClass: "details-block" }, [
                              _c("div", { staticClass: "headline" }, [
                                _vm._v("Customer data")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "order-data" }, [
                                _c("div", [
                                  _c("p", [
                                    _c("span", [_vm._v("Name:")]),
                                    _vm._v(" " + _vm._s(item.contact_name))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("span", [_vm._v("Email:")]),
                                    _vm._v(" " + _vm._s(item.contact_email))
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("span", [_vm._v("Phone:")]),
                                    _vm._v(" " + _vm._s(item.contact_phone))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("p", [
                                    _c("span", [_vm._v("Delivery date:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.parseDate(item.delivery[0].date)
                                        )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("span", [_vm._v("Comment:")]),
                                    _vm._v(" " + _vm._s(item.comment))
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "addresses" },
                                _vm._l(item.delivery, function(
                                  addressItem,
                                  index
                                ) {
                                  return _c("p", { key: index }, [
                                    _c("span", [_vm._v("Address:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          addressItem.address.street_address +
                                            " " +
                                            addressItem.address.city +
                                            " " +
                                            addressItem.address.postal_code
                                        )
                                    )
                                  ])
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "details-block" }, [
                              _c("div", { staticClass: "headline" }, [
                                _vm._v("Products data")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "items" },
                                _vm._l(item.items.items, function(
                                  product,
                                  index
                                ) {
                                  return _c(
                                    "v-card",
                                    { key: index, staticClass: "item" },
                                    [
                                      _c("v-img", {
                                        attrs: {
                                          src: product.attributes.preview,
                                          height: "200px"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-card-title", [
                                        _vm._v(_vm._s(product.title))
                                      ]),
                                      _vm._v(" "),
                                      _c("v-card-subtitle", [
                                        _c("span", [
                                          _vm._v(
                                            "Price: " + _vm._s(product.price)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "Quantity: " +
                                              _vm._s(product.quantity)
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-subtitle",
                                        {
                                          staticStyle: {
                                            "font-size": "1.2rem!important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              product.attributes.description
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "order-bottom" },
                              [
                                _c("span", { staticClass: "subtotal" }, [
                                  _vm._v("Total: "),
                                  _c("span", [
                                    _vm._v(_vm._s(item.items.subtotal))
                                  ])
                                ]),
                                _vm._v(" "),
                                item.status !== "New"
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: "/front/invoice/" + item.uid,
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v("Rechnung")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.status !== "New"
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "/front/delivery-note/" + item.uid,
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v("Lieferung")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.status !== "Completed"
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          outlined: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.openCloseOrder(item.uid)
                                          }
                                        }
                                      },
                                      [_vm._v("Close order")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "load-more" },
                  [
                    _c(
                      "v-btn",
                      { on: { click: _vm.loadMore } },
                      [
                        _c("v-icon", [_vm._v("mdi-reload")]),
                        _vm._v(" Load more")
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _c(
            "div",
            { staticClass: "loader" },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _vm._v(
                  "\n\t\t\t\tIst die Bestellung wirklich abgeschlossen?\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function($event) {
                          _vm.itemToClose = ""
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(" Nein ")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeOrder()
                        }
                      }
                    },
                    [_vm._v(" Ja ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("DeleteDialog", {
        attrs: {
          modal: _vm.deleteModal,
          item: _vm.selectedItem,
          action: _vm.action,
          close: function() {
            _vm.closeDelete()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }